import { PayTableProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/PayTableProperties";
import { AbstractPayTableIconProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractPayTableIconProperties";
import { AbstractPayTableCellProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractPayTableProperties";
import { SlingoStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/SlingoStyle";
import { VerticalLayout } from "@lib/titan2/dist/game/control/layout/VerticalLayout";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { Dictionary } from "@lib/titan2/dist/util/collection/Dictionary";
import * as PIXI from "pixi.js";
/**
 * PayTableLandscapeProperties.ts
 */
export class PayTableLandscapeProperties extends PayTableProperties {
    spacingFunction(index) {
        return [
            //
            38, 32, 32, 30, 28, 22, 16, 16, 4, -2,
        ][index];
    }
    setDefaultValues() {
        super.setDefaultValues();
        // this.position = new PIXI.Point(185, -50);
        // this.scale.set(1.15);
        this.cellProperties = [
            new PayTableCellLandscapeProperties12(),
            new PayTableCellLandscapeProperties10(),
            new PayTableCellLandscapeProperties9(),
            new PayTableCellLandscapeProperties8(),
            new PayTableCellLandscapeProperties7(),
            new PayTableCellLandscapeProperties6(),
            new PayTableCellLandscapeProperties5(),
            new PayTableCellLandscapeProperties4(),
            new PayTableCellLandscapeProperties3(),
            new PayTableCellLandscapeProperties2(),
            new PayTableCellLandscapeProperties1(),
        ];
        this.landscapePrimary = true;
        this.panelProperties.position = new PIXI.Point(130, 152);
        this.panelProperties.layout = new VerticalLayout(this.spacingFunction);
        this.backToGameButtonProperties.visible = false;
        this.animationProperties.position = new PIXI.Point(973, 512);
    }
}
/**
 * PayTableIconLandscapeProperties.ts
 */
export class PayTableIconLandscapeProperties extends AbstractPayTableIconProperties {
    setDefaultValues() {
        this.freeSpinLabelProperties = null;
        this.freeSpinValueProperties = null;
        this.multiplierFieldProperties = null;
        this.iconProperties = new SpriteProperties(SlingoStyle.PAY_TABLE_ICON, SlingoStyle.MODULE);
    }
}
/**
 *  PayTableCellLandscapeProperties.ts
 */
export class PayTableCellLandscapeProperties extends AbstractPayTableCellProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.id = "11";
        this.labelPos = new PIXI.Point(2, 0);
        this.fieldPos = new PIXI.Point(180, 0);
        this.labelSize = new PIXI.Point(168, 77);
        this.fieldSize = new PIXI.Point(230, 44);
        this.orientation = this.orientation || "landscape";
        this.useShortLabel = false;
        this.reInitialiseFieldProperties();
    }
    reInitialiseFieldProperties() {
        super.reInitialiseFieldProperties();
        let effectNames = new Dictionary();
        if (this.orientation === "landscape") {
            effectNames.setValue("1", `ladder/ladder_1_noWin_Landscape`);
            effectNames.setValue("2", `ladder/ladder_2_noWin_landscape`);
            effectNames.setValue("3", `ladder/ladder_3_win_Landscape`);
            effectNames.setValue("4", `ladder/ladder_4_win_landscape`);
            effectNames.setValue("5", `ladder/ladder_5_win_landscape`);
            effectNames.setValue("6", `ladder/ladder_6_win_Landscape`);
            effectNames.setValue("7", `ladder/ladder_7_win_landscape`);
            effectNames.setValue("8", `ladder/ladder_8_win_landscape`);
            effectNames.setValue("9", `ladder/ladder_9_featureWin_landscape`);
            effectNames.setValue("10", `ladder/ladder_10_featureWin_landscape`);
            effectNames.setValue("11", `ladder/ladder_11_featureWin_Landscape`);
        }
        else {
            effectNames.setValue("1", `ladder/ladder_1_noWin_portrait`);
            effectNames.setValue("2", `ladder/ladder_2_noWin_portrait`);
            effectNames.setValue("3", `ladder/ladder_3_win_portrait`);
            effectNames.setValue("4", `ladder/ladder_4_win_portrait`);
            effectNames.setValue("5", `ladder/ladder_5_win_portrait`);
            effectNames.setValue("6", `ladder/ladder_6_win_portrait`);
            effectNames.setValue("7", `ladder/ladder_7_win_portrait`);
            effectNames.setValue("8", `ladder/ladder_8_win_portrait`);
            effectNames.setValue("9", `ladder/ladder_9_featureWin_portrait`);
            effectNames.setValue("10", `ladder/ladder_10_featureWin_portrait`);
            effectNames.setValue("11", `ladder/ladder_11_featureWin_portrait`);
        }
        this.active = `ladder/ladder_${this.orientation}_field${this.id}_active`;
        this.activeEffect = effectNames.getValue(this.id);
        this.off = `ladder/ladder_${this.orientation}_field${this.id}_off`;
    }
}
/**
 * PayTableCellLandscapeProperties12.ts
 */
export class PayTableCellLandscapeProperties12 extends PayTableCellLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.id = "11";
        this.labelPos = new PIXI.Point(-90, 0);
        this.labelSize = new PIXI.Point(115, 44);
        this.reInitialiseFieldProperties();
    }
}
/**
 * PayTableCellLandscapeProperties10.ts
 */
export class PayTableCellLandscapeProperties10 extends PayTableCellLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.id = "10";
        this.labelPos = new PIXI.Point(-90, 0);
        this.labelSize = new PIXI.Point(115, 44);
        this.reInitialiseFieldProperties();
    }
}
/**
 * PayTableCellLandscapeProperties9.ts
 */
export class PayTableCellLandscapeProperties9 extends PayTableCellLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.id = "9";
        this.labelPos = new PIXI.Point(-90, 0);
        this.labelSize = new PIXI.Point(115, 44);
        this.reInitialiseFieldProperties();
    }
}
/**
 * PayTableCellLandscapeProperties8.ts
 */
export class PayTableCellLandscapeProperties8 extends PayTableCellLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.id = "8";
        this.labelPos = new PIXI.Point(-29, 0);
        this.labelSize = new PIXI.Point(115, 44);
        this.reInitialiseFieldProperties();
    }
}
/**
 * PayTableCellLandscapeProperties7.ts
 */
export class PayTableCellLandscapeProperties7 extends PayTableCellLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.id = "7";
        this.labelPos = new PIXI.Point(-29, 0);
        this.labelSize = new PIXI.Point(115, 44);
        this.reInitialiseFieldProperties();
    }
}
/**
 * PayTableCellLandscapeProperties6.ts
 */
export class PayTableCellLandscapeProperties6 extends PayTableCellLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.id = "6";
        this.labelPos = new PIXI.Point(-29, 0);
        this.labelSize = new PIXI.Point(115, 44);
        this.reInitialiseFieldProperties();
    }
}
/**
 * PayTableCellLandscapeProperties5.ts
 */
export class PayTableCellLandscapeProperties5 extends PayTableCellLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.id = "5";
        this.labelPos = new PIXI.Point(37, 0);
        this.labelSize = new PIXI.Point(115, 44);
        this.reInitialiseFieldProperties();
    }
}
/**
 * PayTableCellLandscapeProperties4.ts
 */
export class PayTableCellLandscapeProperties4 extends PayTableCellLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.id = "4";
        this.labelPos = new PIXI.Point(37, 0);
        this.labelSize = new PIXI.Point(115, 44);
        this.reInitialiseFieldProperties();
    }
}
/**
 * PayTableCellLandscapeProperties3.ts
 */
export class PayTableCellLandscapeProperties3 extends PayTableCellLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.id = "3";
        this.labelPos = new PIXI.Point(37, 0);
        this.labelSize = new PIXI.Point(115, 44);
        this.reInitialiseFieldProperties();
    }
}
/**
 * PayTableCellLandscapeProperties2.ts
 */
export class PayTableCellLandscapeProperties2 extends PayTableCellLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.id = "2";
        this.labelPos = new PIXI.Point(37, 0);
        this.labelSize = new PIXI.Point(115, 44);
        this.reInitialiseFieldProperties();
    }
}
/**
 * PayTableCellLandscapeProperties1.ts
 */
export class PayTableCellLandscapeProperties1 extends PayTableCellLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.id = "1";
        this.labelPos = new PIXI.Point(37, 0);
        this.labelSize = new PIXI.Point(115, 44);
        this.reInitialiseFieldProperties();
    }
}
